var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "hotel_calendar--container",
      class: { "hotel_calendar--container-vertical": _vm.isDisplayVertical },
      style: { "--months-to-show": _vm.calendarMonthsToShow },
    },
    [
      _vm.calendarInitialized
        ? _c(
            "div",
            {
              staticClass: "calendar--container",
              class: _vm.calendarContainerClasses,
            },
            [
              _c(
                "a",
                {
                  staticClass: "calendar--nav calendar--nav-previous",
                  class: _vm.calendarPrevClasses,
                  attrs: { href: "#", title: "Navigate to previous month" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.seekMonth(-1)
                    },
                  },
                },
                [
                  _c("svg", [
                    _c("use", {
                      attrs: {
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xlink:href": "#ic_chevron_left_24px",
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "calendar--nav calendar--nav-next",
                  class: _vm.calendarNextClasses,
                  attrs: { href: "#", title: "Navigate to next month" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.seekMonth(1)
                    },
                  },
                },
                [
                  _c("svg", [
                    _c("use", {
                      attrs: {
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xlink:href": "#ic_chevron_right_24px",
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "calendar--grid" },
                _vm._l(_vm.calendarMonths, function (month, monthIndex) {
                  return _c("hotel-calendar-month", {
                    key: month.year + "-" + month.month,
                    ref: "month-" + month.year + "-" + month.month,
                    refInFor: true,
                    class: _vm.getMonthClasses(
                      monthIndex,
                      _vm.calendarCurrentMonthIndex
                    ),
                    attrs: { month: month },
                    on: {
                      close: function ($event) {
                        return _vm.$emit("close")
                      },
                      seek: _vm.seekMonth,
                    },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("hotel-calendar-footer", {
                on: {
                  close: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.calendarInitialized
        ? _c("loading-spinner", { staticClass: "hotel_calendar--rate_loader" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }